import { createApp } from 'vue'
import ProductCard from './ProductCard'

const el = '.kb-component--product-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ProductCardDOM) => {
            const props = {
                data: ProductCardDOM.dataset.product ? JSON.parse(ProductCardDOM.dataset.product) : {},
            }
            const component = createApp(ProductCard, props).use(Store)
            component.mount(ProductCardDOM)
        })
    }
}
